"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _Link = _interopRequireDefault(require("@insided/destination/icons/Link"));

var _Menu = _interopRequireDefault(require("@insided/destination/icons/Menu"));

var _ToggleSwitch = _interopRequireDefault(require("@insided/shared/uikit/ToggleSwitch"));

var _ExternalLink = _interopRequireDefault(require("@insided/shared/icons/ExternalLink"));

var _SettingsGear = _interopRequireDefault(require("@insided/shared/icons/SettingsGear"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

var _DragHandle = _interopRequireDefault(require("../DragHandle"));

var _Eye = _interopRequireDefault(require("@insided/destination/icons/Eye"));

var _common = require("@insided/shared/utils/common");

var _InlineTitleEditor = _interopRequireDefault(require("./InlineTitleEditor"));

var _MenuItemSegmentVisibility = _interopRequireWildcard(require("../MenuItemSegmentVisibility"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isMegaMenuV2Enabled = _common.common.isModuleActive('megaMenuV2');

var isCustomDropdownsEnabled = _common.common.isModuleActive('customDropdowns');

/**
 * Collapsible card component for custom dropdown navigation items.
 * Provides inline editing for title and URL while keeping modal-based
 * dropdown items management.
 */
var CollapsibleDropdownCard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CollapsibleDropdownCard, _Component);

  var _super = _createSuper(CollapsibleDropdownCard);

  function CollapsibleDropdownCard() {
    var _this;

    (0, _classCallCheck2.default)(this, CollapsibleDropdownCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "urlInputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isEditingTitle: false,
      isEditingUrl: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTitleEditClick", function (e) {
      e.stopPropagation();

      _this.setState({
        isEditingTitle: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleUrlClick", function (e) {
      e.stopPropagation();

      _this.setState({
        isEditingUrl: true
      }, function () {
        var _this$urlInputRef, _this$urlInputRef2;

        (_this$urlInputRef = _this.urlInputRef) === null || _this$urlInputRef === void 0 ? void 0 : _this$urlInputRef.focus();
        (_this$urlInputRef2 = _this.urlInputRef) === null || _this$urlInputRef2 === void 0 ? void 0 : _this$urlInputRef2.select();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleUrlBlur", function () {
      _this.setState({
        isEditingUrl: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleUrlKeyDown", function (e) {
      if (e.key === 'Enter' || e.key === 'Escape') {
        e.preventDefault();

        _this.setState({
          isEditingUrl: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMenuActions", function () {
      return [{
        title: 'Edit Title',
        onClick: _this.handleTitleEditClick
      }, {
        title: 'Delete',
        variant: 'danger',
        onClick: function onClick() {
          return _this.props.onRemove();
        }
      }];
    });
    return _this;
  }

  (0, _createClass2.default)(CollapsibleDropdownCard, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _item$name,
          _item$url,
          _item$isDropdown,
          _item$segmentVisibili;

      var _this$props = this.props,
          item = _this$props.item,
          isExpanded = _this$props.isExpanded,
          widgetPersonalisationOptions = _this$props.widgetPersonalisationOptions,
          onToggleExpanded = _this$props.onToggleExpanded,
          onItemUrlChanged = _this$props.onItemUrlChanged,
          onItemExternalChanged = _this$props.onItemExternalChanged,
          onItemVisibilityChanged = _this$props.onItemVisibilityChanged,
          onSegmentVisibilityChanged = _this$props.onSegmentVisibilityChanged,
          onItemDropdownChanged = _this$props.onItemDropdownChanged,
          onShowDropdownSettings = _this$props.onShowDropdownSettings;
      var _this$state = this.state,
          isEditingTitle = _this$state.isEditingTitle,
          isEditingUrl = _this$state.isEditingUrl;
      return (0, _preact.h)("div", {
        className: "collapsible-dropdown-card",
        "data-qa": "collapsible-card-".concat(item.name.split(' ').join('_'))
      }, isEditingTitle ? (0, _preact.h)(_InlineTitleEditor.default, {
        initialValue: item.name,
        isExpanded: isExpanded,
        onConfirm: function onConfirm(value) {
          _this2.props.onItemNameChanged(value);

          _this2.setState({
            isEditingTitle: false
          });
        },
        onCancel: function onCancel() {
          _this2.setState({
            isEditingTitle: false
          });
        }
      }) : (0, _preact.h)("div", {
        className: (0, _classnames.default)('collapsible-dropdown-card__header-wrapper', {
          'collapsible-dropdown-card__header-wrapper--expanded': isExpanded,
          'collapsible-dropdown-card__header-wrapper--v2': isMegaMenuV2Enabled
        })
      }, (0, _preact.h)("button", {
        className: "collapsible-dropdown-card__header",
        "aria-label": item.name ? "".concat(item.name, " dropdown") : 'Dropdown',
        "aria-expanded": isExpanded,
        onClick: onToggleExpanded
      }, !isMegaMenuV2Enabled && (0, _preact.h)(_DragHandle.default, null), (0, _preact.h)("span", {
        className: "collapsible-dropdown-card__title-text"
      }, (_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : 'Dropdown name')), (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__actions"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "collapsible-dropdown-card__visibility-btn",
        onClick: function onClick(e) {
          e.stopPropagation();
          onItemVisibilityChanged();
        },
        "aria-label": item.visibility ? 'Hide item' : 'Show item'
      }, !isMegaMenuV2Enabled && (0, _preact.h)(_Eye.default, {
        width: 18,
        height: 18,
        style: {
          opacity: item.visibility ? 1 : 0.5
        }
      })), (0, _preact.h)(_DropdownControl.default, {
        align: "right",
        triggerClass: "collapsible-dropdown-card__dropdown",
        trigger: (0, _preact.h)("button", {
          type: "button",
          className: "dropdown-settings__action-btn",
          "aria-label": "More options"
        }, (0, _preact.h)(_MoreHoriz.default, {
          width: 20,
          height: 20
        })),
        items: this.getMenuActions(),
        closeOnDropdownClick: true
      }), (0, _preact.h)("button", {
        type: "button",
        className: "collapsible-dropdown-card__chevron",
        onClick: function onClick(e) {
          e.stopPropagation();
          onToggleExpanded();
        },
        "aria-label": isExpanded ? 'Collapse' : 'Expand',
        "aria-expanded": isExpanded
      }, isExpanded ? (0, _preact.h)(_ChevronUp.default, null) : (0, _preact.h)(_ChevronDown.default, null)))), (0, _preact.h)("div", {
        className: (0, _classnames.default)('collapsible-dropdown-card__body', {
          'collapsible-dropdown-card__body--expanded': isExpanded
        })
      }, (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__body-content"
      }, (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__field-section collapsible-dropdown-card__url-section"
      }, (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__menu-row"
      }, (0, _preact.h)(_Link.default, {
        width: 24,
        height: 24
      }), isEditingUrl ? (0, _preact.h)("input", {
        ref: function ref(_ref) {
          _this2.urlInputRef = _ref;
        },
        type: "text",
        className: "collapsible-dropdown-card__url-input",
        value: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '',
        onChange: function onChange(e) {
          return onItemUrlChanged(e.target.value);
        },
        onBlur: this.handleUrlBlur,
        onKeyDown: this.handleUrlKeyDown,
        placeholder: "URL"
      }) : (0, _preact.h)("button", {
        type: "button",
        className: "collapsible-dropdown-card__url-text-btn",
        onClick: this.handleUrlClick
      }, item.url ? item.url : 'URL')), (0, _preact.h)("hr", {
        className: "collapsible-dropdown-card__divider"
      }), (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__menu-row"
      }, (0, _preact.h)(_ExternalLink.default, {
        width: 24,
        height: 24
      }), (0, _preact.h)("span", {
        id: "collapsible-external-link-label"
      }, "Open in new tab"), (0, _preact.h)(_ToggleSwitch.default, {
        checked: !!item.external,
        onChange: onItemExternalChanged,
        "aria-labelledby": "collapsible-external-link-label"
      })), (0, _preact.h)("hr", {
        className: "collapsible-dropdown-card__divider"
      }), (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__menu-row"
      }, (0, _preact.h)(_Menu.default, {
        width: 24,
        height: 24
      }), (0, _preact.h)("span", {
        id: "collapsible-dropdown-label"
      }, "Dropdown"), (0, _preact.h)("div", {
        className: "collapsible-dropdown-card__settings-row"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "collapsible-dropdown-card__settings-btn",
        onClick: function onClick(e) {
          e.stopPropagation();
          onShowDropdownSettings();
        },
        "aria-label": "Dropdown settings"
      }, (0, _preact.h)(_SettingsGear.default, {
        width: 24,
        height: 24
      })), (0, _preact.h)(_ToggleSwitch.default, {
        checked: (_item$isDropdown = item.isDropdown) !== null && _item$isDropdown !== void 0 ? _item$isDropdown : false,
        onChange: function onChange() {
          return onItemDropdownChanged();
        },
        "aria-labelledby": "collapsible-dropdown-label"
      }))), isCustomDropdownsEnabled && [(0, _preact.h)("hr", {
        key: "divider",
        className: "collapsible-dropdown-card__divider"
      }), (0, _preact.h)(_MenuItemSegmentVisibility.default, {
        key: "segment-visibility",
        config: (_item$segmentVisibili = item.segmentVisibility) !== null && _item$segmentVisibili !== void 0 ? _item$segmentVisibili : (0, _MenuItemSegmentVisibility.getDefaultSegmentVisibility)(),
        widgetPersonalisationOptions: widgetPersonalisationOptions,
        onChange: onSegmentVisibilityChanged
      })]))));
    }
  }]);
  return CollapsibleDropdownCard;
}(_preact.Component);

var _default = CollapsibleDropdownCard;
exports.default = _default;